import ShipperPriceCell from './container';

export default ShipperPriceCell;
